export var DigitalCardStatus;
(function (DigitalCardStatus) {
    DigitalCardStatus["ACTIVE"] = "ACTIVE";
    DigitalCardStatus["SUSPENDED"] = "SUSPENDED";
    DigitalCardStatus["EXPIRED"] = "EXPIRED";
    DigitalCardStatus["PENDING"] = "PENDING";
    DigitalCardStatus["CANCELLED"] = "CANCELLED";
})(DigitalCardStatus || (DigitalCardStatus = {}));
//# sourceMappingURL=DigitalCardStatus.js.map